<template>
	<div class="pa-2">
		<v-form ref="form" v-model="isValid">
			<v-combobox
				ref="combobox"
				v-model="delivery.company"
				:rules="[rules.required]"
				label="納入先を探す"
				item-text="name"
				item-value="id"
				class="mt-4"
				outlined
				dense
				:hint="hint"
				@keyup="setSearchCompany"
				@change="changeCompany"
				:items="companies"
				no-data-text="選択肢がありません"
			/>

			<v-combobox
				v-model="delivery.person"
				:items="persons"
				class="mt-4"
				label="納入先担当者"
				outlined
				dense
				item-text="name"
				item-value="name"
			/>

			<v-text-field
				v-model.trim="delivery.zipcode"
				label="〒郵便番号"
				:rules="[rules.zipcode]"
				class="mt-4"
				hint="ﾊｲﾌﾝ有り"
				outlined
				dense
			></v-text-field>

			<v-text-field
				v-model.trim="delivery.address"
				:rules="[rules.required]"
				label="住所"
				class="mt-4"
				outlined
				dense
			></v-text-field>

			<v-select
				v-model="delivery.prefecture"
				label="都道府県"
				class="mt-4"
				outlined
				dense
				:items="prefectures"
			>
			</v-select>

			<v-text-field
				v-model.trim="delivery.city"
				label="市郡町村"
				class="mt-4"
				outlined
				dense
			></v-text-field>

			<v-text-field
				v-model.trim="delivery.phone"
				label="電話番号"
				class="mt-4"
				outlined
				dense
			></v-text-field>

			<v-text-field
				v-model.trim="delivery.fax"
				label="Fax"
				class="mt-4"
				outlined
				dense
			></v-text-field>
		</v-form>
	</div>
</template>

<script>
import rules from "../../../helper/rules"
import axios from "axios"
import authenticate from "../../../helper/authenticate"

export default {
	props: {
		delivery: {
			type: Object,
			required: false,
			default: () => {},
		},
	},
	data({ $store }) {
		return {
			rules,
			companies: [],
			persons: [],
			companyKeyword: null,
			searchCompanyTimer: null,
			errorCompanyFlag: false,
			prefecture: null,
			prefectures: $store.state.prefectures,
		}
	},
	methods: {
		setSearchCompany(e) {
			if (e.key == "ArrowDown" || e.key == "ArrowUp") return // 上下移動はセレクトの選択に利用するので、利用するので、アクションを起こさない
			this.companies = []

			this.companyKeyword = e.target.value
			clearTimeout(this.searchCompanyTimer) // 連続でタイプした時用に前のタイマーをキャンセル
			if (!this.companyKeyword.length) return // 0文字の場合はreturn
			this.searchCompanyTimer = setTimeout(this.searchCompany, 500) // 連続でタイプするとアクセスが走りすぎるため.5秒後に発火
		},
		searchCompany() {
			const params = {
				q: {
					name_cont: this.companyKeyword,
				},
			}
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/search_customer_companies", {
					headers,
					params,
				})
				.then((res) => {
					this.searchCompanyTimer = null
					this.companies = res.data.customer_companies
					this.errorCompanyFlag = false
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		changeCompany() {
			// テキスト追加時の削除
			if (!this.companies.includes(this.delivery.company)) {
				this.errorCompanyFlag = true
				this.delivery.company = null
				this.$refs.combobox.reset()
				this.$refs.form.reset()
			}
			// 納入先担当者をセット
			this.persons = []
			if (this.delivery.company) {
				this.persons = this.delivery.company.customer_persons

				// 住所等を自動セット
				this.delivery.zipcode = this.delivery.company.zipcode
				this.delivery.address = this.delivery.company.address
				this.delivery.prefecture = this.delivery.company.prefecture
				this.delivery.city = this.delivery.company.city
				this.delivery.phone = this.delivery.company.phone
				this.delivery.fax = this.delivery.company.fax
			}
		},
		isPresence(value) {
			return value !== null && value !== ""
		},
	},
	computed: {
		hint() {
			if (this.companies.length) {
				return "納入先を選択してください"
			} else if (this.searchEndUserTimer) {
				return "納入先を取得しています"
			} else if (!this.companies.length && this.companyKeyword) {
				return "該当する納入先が存在していません"
			} else if (this.errorCompanyFlag && !this.companyKeyword) {
				return "選択肢から納入先を選択してください"
			} else {
				return "納入先を入力してください"
			}
		},
		isValid: {
			get() {
				return this.isPresence(this.delivery.address) && this.isPresence(this.delivery.company)
			},
			set() {
				this.$emit(
					"delivery_form_valid",
					this.isPresence(this.delivery.address) && this.isPresence(this.delivery.company)
				)
			},
		},
	},
}
</script>
